import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const baseConfig = {
	className: 'toast-minimal',
	bodyClassName: 'toast-body',
	hideProgressBar: false,
	closeOnClick: true,
	pauseOnHover: true,
	draggable: true,
};

export const mostrarExito = (mensaje: string) => {
	toast.success(mensaje, {
		...baseConfig,
	});
};

export const mostrarError = (mensaje: string) => {
	toast.error(mensaje, {
		...baseConfig,
	});
};

export const mostrarAviso = (mensaje: React.ReactNode) => {
	toast.warning(mensaje, {
		...baseConfig,
	});
};

export const mostrarInfo = (mensaje: React.ReactNode) => {
	toast.info(mensaje, {
		...baseConfig,
	});
};

